<template>
    <div>
        <modal class="biz-contract-release" :display="modalStatus.bizContractRelease" @modalStatus="closeModal" >
            <alarm-msg-white type="ERROR" :msg="alarm.error.msg" :count="alarm.error.count" :showAlarm="alarm.error.status" @timeOut="alarm.error.status=false"></alarm-msg-white>
            <h1>{{title}}</h1>
            <div class="biz-contract-release-wrap" :key="'height'+componentKey">
                <div class="contract-info">
                    <div class="address">
                        {{obj.address}}
                    </div>
                    <div class="contract-period">
                        租期：{{getFormatDateTime(obj.contractBeginDate)}} ～ {{getFormatDateTime(obj.contractEndDate)}}
                    </div>
                    <div class="rent-price">
                        租金：{{toCurrency(obj.rentPrice)}}
                    </div>
                </div>
                <div class="tenant-info">
                    <div>
                        房客姓名：{{releaseInfo.tenantName}}
                    </div>
                    <div>
                        聯絡方式：{{releaseInfo.tenantPhone}}
                    </div>
                    <div v-if="releaseInfo.tenantReleaseReason">
                        退租原因：{{transReleaseReason(releaseInfo.tenantReleaseReason)}}
                    </div>
                    <div v-if="releaseInfo.tenantReleaseApplyTime">
                        申請時間：{{getFormatDateTime(releaseInfo.tenantReleaseApplyTime)}}
                    </div>
                    <div v-if="releaseInfo.tenantReleaseTime">
                        退租日期：{{getFormatDateTime(releaseInfo.tenantReleaseTime)}}
                    </div>
                    <div v-if="releaseInfo.tenantReleaseNote">
                        備註：{{releaseInfo.tenantReleaseNote}}
                    </div>
                </div>
            </div>
            <div v-if="isRelease && isTool && !obj.isLandlordReleasedContract" class="btn-group">
                <button v-if="bizAuth.viewBillRecord.hasRight" class="border-button reject" @click="toBillDetail(obj.address)">帳單紀錄</button>
                <button class="default-button confirm" @click="releaseContract()">退租點交</button>
            </div>
        </modal>
    </div>
</template>
<script>
import Modal from '@/components/widge/Modal.vue';
import alarmMsgWhite from '@/components/bussiness/widges/alarms/alarmMsgWhite.vue';
import { mapGetters } from 'vuex'

import { 
    apiBizGetContractReleaseInfo,
    } from "@/apis/api.js"; 

export default {
    data () {
        return {
            componentKey: 0,
            releaseInfo: {},
            title: null,
            alarm: {
                success:{
                    status: false,
                    msg: null,
                    count: 2000
                },
                error:{
                    status: false,
                    msg: null,
                    count: 2000
                }
            },
        }
    },
    props:{
        cid: null,
        isTool: {
            default: true
        },
        obj: {}
    },
    mounted (){
        if(this.$route.hash != '#%E7%B5%90%E6%9D%9F%E5%90%88%E7%B4%84'){
            this.title = '房客已申請退租'
        }else{
            this.title = '退租明細'
        }
        this.$store.dispatch('getHouseConfig')
    },
    destroyed() {
    },
    watch: {
        cid: {
            handler: function (val) {
                this.getContractReleaseInfo(val)
            },
            immediate: true
        },
    },
    methods: {
        closeModal: function (type) {
            this.$store.dispatch('setModalStatus', {state: false, type: 'bizContractRelease'})
        },
        getContractReleaseInfo: function (cid) {
            if(cid){
                let data = cid
                apiBizGetContractReleaseInfo(data)
                .then(res => {
                    console.log('getContractReleaseInfo',res)
                    if( res.data.status == "SUCCESS" ){
                        this.releaseInfo = res.data.result
                    }
                })
                .catch(err => {
                    console.log(err)
                })
            }
            
        },
        releaseContract: function () {
            this.closeModal()
            if(this.obj.isPaperContract){
                this.$router.push({name: 'bizContractDefault', query: {'contractCid': this.cid, 'mode': 'contract', 'type': 'release','file': 'pdf'}})
            }else{
                this.$router.push({name: 'bizContractDefault', query: {'contractCid': this.cid, 'mode': 'contract', 'type': 'release'}})
            }
        },
        toBillDetail: function (data) {
            this.closeModal()
            let routerUrl = this.$router.resolve({ name: 'billMgt', query: { 'filterWord': data }})
            window.open(routerUrl.href, '_blank');
        },
        transReleaseReason: function (val) {
            let releaseReason = this.houseConfig.releaseReason

            for (let i = 0; i < releaseReason.length; i++) {
                const element = releaseReason[i];
                if(element.name == val){
                    return element.desc
                }
                
            }
        },
    },
    computed: {
        isRelease: function () {
            let today = new Date()
            let releaseDate = new Date(this.releaseInfo.tenantReleaseTime)
            if(today>releaseDate){
                return true
            }else{
                return false
            }
        }, 
        ...mapGetters({
            bizAuth: 'GET_BIZ_AUTH',
            modalStatus: 'GET_MODAL_STATUS',
            houseConfig: 'GET_HOUSE_CONFIG'
        })
    },
    components: {
        Modal,
        alarmMsgWhite,
    }
}
</script>
<style lang="scss">
    #modal.biz-contract-release{
        .modal-content{
            width: 448px;
            padding: 0 !important;
            .detail{
                >h1{
                    margin-top: 32px;
                    margin-bottom: 20px;
                }
                .alarm-msg{
                    top: 10px;
                }
                .biz-contract-release-wrap{
                    width: 100%;
                    box-sizing: border-box;
                    padding: 0 32px 32px 32px;
                    max-height: 415px;
                    overflow-x: hidden;
                    &::-webkit-scrollbar {
                        display: none;
                    }
                    .contract-info{
                        padding: 16px;
                        border-radius: 6px;
                        border: solid 1px #f3f3f3;
                        margin-bottom: 24px;
                        .address{
                            font-size: 16px;
                            font-weight: 500;
                            margin-bottom: 4px;
                        }
                        .contract-period{
                            color: #676362;
                            margin-bottom: 4px;
                        }
                        .rent-price{
                            color: #676362;
                        }
                    }
                    .tenant-info{
                        >div{
                            margin-bottom: 12px;
                            word-break: break-all;
                            line-height: 1.5;
                        }
                    }
                }
            }
            
            .btn-group{
                display: flex;
                justify-content: center;
                align-items: center;
                width: 100%;
                height: 84px;
                box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                border-radius:  0 0 20px 20px;
                margin: 0 auto;
                button{
                    width: 184px;
                    height: 44px;
                }
                button.reject{
                    margin-right: 16px;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/widges/modals/contractRelease.vue